<template>
    <div>
        <v-dialog v-model="abrir" width="1000" persistent >
            <v-card class="pb-1">
                <v-card-title class="justify-space-between">
                    <span class="headline">Detalle de reproceso de aceite</span>
                    <div>
                        <v-btn class="mx-2" color="red darken-1" dark @click="abrir = false">Cerrar</v-btn>
                    </div>
                </v-card-title>
                <v-col cols="12" class="py-0">
                    <v-card class="my-6">
                        <v-row>
                            <v-progress-linear 
                                v-if="cargando_datos || cargando_reproceso"
                                indeterminate
                                color="#0D47A1"
                            ></v-progress-linear>
                        </v-row>
                        <v-row class="pl-1 pr-1">
                            <v-col cols="3">
                                <label>Fecha Ingreso</label>
                                <date-picker 
                                    v-model="ingreso_reproceso.fecha" 
                                    placeholder ="Seleccione Fecha"
                                    label ="Seleccione Fecha" 
                                    format="DD-MM-YYYY" 
                                    :default-value="ingreso_reproceso.fecha" 
                                    valueType="YYYY-MM-DD"
                                ></date-picker>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field 
                                    v-model="ingreso_reproceso.guia" 
                                    label="Guía" 
                                    placeholder="Guía"
                                ></v-text-field>
                            </v-col>
                            <!-- BODEGA ORIGEN NO MODIFICABLE -->
                            <v-col cols="3">
                                <v-select
                                    :items="[reproceso.bodega_origen]"
                                    v-model="reproceso.bodega_origen"
                                    label="Bodega Destino"
                                    readonly
                                ></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field 
                                    v-model="ingreso_reproceso.observaciones" 
                                    label="Observaciones (opcional)" 
                                    placeholder="Observaciones"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" class="pb-0 pt-0">
                                <v-select
                                    v-model="ingreso_reproceso.estanque_destino"
                                    :items="estanques_filtrados"
                                    label="Estanque Destino"
                                    item-text="nombre_corto"
                                    item-value="id"
                                    color="blue darken-3"
                                    class="pt-0"
                                    persistent-hint
                                ></v-select>
                            </v-col>
                            <v-col cols="3" class="pt-0">
                                <v-text-field 
                                    v-model="ingreso_reproceso.cantidad" 
                                    label="Cantidad" 
                                    placeholder="Cantidad"
                                    class="pt-0"
                                    type="number"
                                    :rules="[validarCantidad]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" class="pb-0 pt-0">
                                <v-text-field 
                                    v-model="ingreso_reproceso.folio_abastecimiento" 
                                    label="Folio Abastecimiento (opcional)" 
                                    placeholder="Folio Abastecimiento"
                                    class="pt-0"    
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" class="pb-0 pt-0">
                                <v-select
                                    v-model="ingreso_reproceso.lote_id"
                                    :items="lotes_filtrados"
                                    label="Lote Destino"
                                    item-text="nombre_lote"
                                    item-value="id"
                                    color="blue darken-3"
                                    class="pt-0"
                                    persistent-hint
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card>

                    <div class="table-wrap">
                        <v-simple-table
                            fixed-header
                            width="100%"
                        >
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th width="7%" class="cabecera borde-left">Fecha Prod.</th>
                                        <th width="5%" class="cabecera borde-left">Cant Desp.</th>
                                        <th width="7%" class="cabecera borde-left">Fecha Abast.</th>
                                        <th width="5%" class="cabecera borde-left">Folio Ab.</th>
                                        <th width="5%" class="cabecera borde-left">Estanque</th>
                                        <th width="10%" class="cabecera borde-left">Lote</th>
                                        <th width="5%" class="cabecera borde-left">Litros</th>
                                        <th width="5%" class="cabecera borde-left">Despachado</th>
                                        <th width="5%" class="cabecera borde-left">Disponible</th>
                                    </tr>
                                </thead>

                                <tr v-for="(item) in detalle" :key="item.id">
                                    <td class="filita"><p>{{item.fecha_prod | formatearFecha}}</p></td>
                                    <td class="filita"><p>{{item.cantidad_desp}}</p></td>
                                    <td class="filita"><p v-if="item.mostrar == 1">{{item.fecha_mov | formatearFecha}}</p></td>
                                    <td class="filita"><p v-if="item.mostrar == 1">{{item.mov_folio_ab}}</p></td>
                                    <td class="filita"><p v-if="item.mostrar == 1">{{item.tk_destino}}</p></td>
                                    <td class="filita"><p v-if="item.mostrar == 1">{{item.mov_lote}}</p></td>
                                    <td class="filita"><p v-if="item.mostrar == 1">{{item.mov_litros}}</p></td>
                                    <td class="filita"><p v-if="item.mostrar == 1">{{item.despachado}}</p></td>
                                    <td class="filita">
                                        <p v-if="item.mostrar == 1">{{ parseInt(item.mov_litros || 0) - parseInt(item.despachado || 0) }}</p>
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </div>

                    <v-btn dark color="green light-darken-1" @click="abrirModalLote">Crear Lote Aceite</v-btn>
                    <v-col class="d-flex justify-center">
                        <v-btn color="green darken-1"  :dark="true" :disabled="!campos_validos" @click="registrarIngresoReproceso">{{ modificar ? 'Modificar' : 'Registrar' }}</v-btn>
                    </v-col>
                </v-col>
            </v-card>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-dialog>
        <modal-lotes-aceite></modal-lotes-aceite>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// Modal de crear lotes
import Modal_Lotes_Aceite from '@/components/shared/Modal_Lotes_Aceite.vue';

export default {
    props: {
        estanques: Array,
        lotes_externos: Array,
    },
    data() {
        return {
            abrir: false,
            cargando_reproceso: false,
            reproceso: {},
            detalle: [],
            cantidad: "",
            modificar: false,
            //A ingresar
            ingreso_reproceso: {
                fecha: new Date().toISOString().substr(0, 10), 
                guia: "",
                observaciones: "",
                estanque_destino: 0,
                cantidad: 0,
                folio_abastecimiento: "",
                lote_id: 0,
            },
        }
    },
    mounted(){
        this.$parent.$on('abrir_modal_detalle', async (reproceso)=>{
            this.reproceso = reproceso;
            this.limpiar();
            this.mostrarLoading({ titulo:'Buscando información del reproceso...', color:'blue' })
            this.buscarDetalleReproceso().then(res => {
                this.abrir = true;
                this.ocultarLoading();
            })
        });
    },
    methods: {
        async buscarDetalleReproceso() {
            let url = `${this.base_url}despacho_aceite/detalle_reproceso/${this.reproceso.id}`;
            await this.axios.get(url, this.headers).then(response => {
                this.detalle = response.data.data;
                const responseIngreso = response.data.ingresoReproceso;
                if(responseIngreso) {
                    this.modificar = true;

                    this.ingreso_reproceso.fecha = responseIngreso.fecha;
                    this.ingreso_reproceso.guia = responseIngreso.guia;
                    this.ingreso_reproceso.observaciones = responseIngreso.observaciones;
                    this.ingreso_reproceso.estanque_destino = responseIngreso.estanque_destino;
                    this.ingreso_reproceso.cantidad = responseIngreso.cantidad;
                    this.ingreso_reproceso.folio_abastecimiento = responseIngreso.folio_abastecimiento;
                    this.ingreso_reproceso.lote_id = responseIngreso.lote_id;
                }
            }).catch((error)=>{
                console.error(error);
                this.errorMessage(error, "Error al cargar detalle del reproceso");
            });
        },
        async registrarIngresoReproceso() {
            this.cargando_reproceso = true;
            this.mostrarLoading({ titulo: `${this.modificar ? "Modificando " : "Registrando "} ingreso de reproceso`, color: "blue"})
            const data = {
                ...this.ingreso_reproceso,
                bod_destino: this.reproceso.bodega_origen_id,
            }
            const url = `${this.base_url}despacho_aceite/ingreso_reproceso/${this.reproceso.id}`;
            await this.axios.post(url, data, this.headers).then(res => {
                this.ocultarLoading();
                this.modificar = true;
                this.cargando_reproceso = false;
                this.abrir = false;
            }).catch((error)=>{
                console.error(error);
                this.cargando_reproceso = false;
                this.errorMessage(error, "Error al registrar un ingreso de reproceso");
            });
        },
        abrirModalLote() {
            const configuracion = { titulo:'Crear Nuevo Lote de Aceite Externo', bodega:this.reproceso.bodega_origen_id };
            Event.$emit('modalcitah', configuracion);
        },
        limpiar() {
            this.modificar = false;
            this.ingreso_reproceso = {
                fecha: new Date().toISOString().substr(0, 10), 
                guia: "",
                observaciones: "",
                estanque_destino: 0,
                cantidad: 0,
                folio_abastecimiento: "",
                lote_id: 0,
            };
        },
        validarCantidad(value) {
            return value <= parseInt(this.reproceso.cantidad_salida) || `Cantidad máxima es ${this.reproceso.cantidad_salida}`;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        estanques_filtrados() {
            return this.estanques.filter(estanque => estanque.bodegas_id === this.reproceso.bodega_origen_id);
        },
        lotes_filtrados() {
            return this.lotes_externos.filter(lote => lote.estanques_externos_id === this.ingreso_reproceso.estanque_destino);
        },
        cargando_datos() {
            return !this.estanques || !this.lotes_externos;
        },
        campos_validos() {
            // Si cantidad máxima es superada
            if(typeof this.validarCantidad(this.ingreso_reproceso.cantidad) === "string") return false;

            const validos = Object.entries(this.ingreso_reproceso).every(([key, value]) => {
                // Campos opcionales
                if(key === "observaciones") return true;
                if(key === "folio_abastecimiento") return true;

                return value
            });
            return validos;
        },
        ...mapState(['base_url','headers'])
    },
    components: {
        ConfirmDialogue,
        DatePicker,
        'modal-lotes-aceite': Modal_Lotes_Aceite,
    }
}
</script>

<style scoped>

.filita{padding: 0em 1em; border-bottom:1px solid hsl(206, 99%, 31%) !important;}
.mx-datepicker{ width: 100% !important;}

</style>